var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "entry-page" },
    [
      _c("NavBar"),
      _c(
        "div",
        { staticClass: "about-page" },
        [
          _vm.carousel[0]
            ? _c(
                "section",
                { staticClass: "carouselStyle" },
                [
                  _c("img", {
                    staticClass: "computer",
                    staticStyle: { opacity: "0" },
                    attrs: { src: _vm.carousel[0].BannerPic, alt: "" },
                  }),
                  _c("img", {
                    staticClass: "mobile",
                    staticStyle: { opacity: "0" },
                    attrs: { src: _vm.carousel[0].BannerPicMobile, alt: "" },
                  }),
                  _c(
                    "el-carousel",
                    {
                      attrs: {
                        interval: 5000,
                        arrow: "always",
                        "indicator-position": "none",
                      },
                    },
                    _vm._l(_vm.carousel, function (item) {
                      return _c("el-carousel-item", { key: item.Guid }, [
                        _c("img", {
                          staticClass: "computer",
                          attrs: { src: item.BannerPic, alt: "" },
                        }),
                        _c("img", {
                          staticClass: "mobile",
                          attrs: { src: item.BannerPicMobile, alt: "" },
                        }),
                      ])
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "a",
            {
              staticStyle: {
                position: "absolute",
                bottom: "10%",
                left: "50%",
                transform: "translate(-50%, 0)",
                "z-index": "10000",
              },
              attrs: { href: "#about-list" },
            },
            [
              _c("eva-icon", {
                attrs: {
                  name: "arrowhead-down-outline",
                  fill: "#F7F9F9",
                  width: "30",
                  height: "30",
                },
              }),
            ],
            1
          ),
          [
            _vm._l(_vm.block, function (item) {
              return _c(
                "div",
                { key: item.Guid, attrs: { id: "about-list" } },
                [
                  item.Position === "無"
                    ? _c("section", { staticClass: "block-text" }, [
                        _c("div", { staticClass: "text-wrap" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.Title)),
                          ]),
                          _c("div", { staticClass: "desc" }, [
                            _c("pre", [_vm._v(_vm._s(item.Content))]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  item.Position === "左"
                    ? _c("section", { staticClass: "block-img-left" }, [
                        _c("div", { staticClass: "text-wrap" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.Title)),
                          ]),
                          _c("div", { staticClass: "desc" }, [
                            _c("pre", [_vm._v(_vm._s(item.Content))]),
                          ]),
                        ]),
                        _c("div", { staticClass: "img-wrap" }, [
                          _c("img", { attrs: { src: item.Pic, alt: "" } }),
                        ]),
                      ])
                    : _vm._e(),
                  item.Position === "右"
                    ? _c("section", { staticClass: "block-img-right" }, [
                        _c("div", { staticClass: "text-wrap" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.Title)),
                          ]),
                          _c("div", { staticClass: "desc" }, [
                            _c("pre", [_vm._v(_vm._s(item.Content))]),
                          ]),
                        ]),
                        _c("div", { staticClass: "img-wrap" }, [
                          _c("img", { attrs: { src: item.Pic, alt: "" } }),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            _c("div", { staticStyle: { position: "relative" } }, [
              _c(
                "a",
                {
                  staticStyle: {
                    position: "absolute",
                    bottom: "10%",
                    left: "50%",
                    transform: "translate(-50%, 0)",
                    "z-index": "999",
                  },
                  attrs: { href: "#job-lists" },
                },
                [
                  _c("eva-icon", {
                    attrs: {
                      name: "arrowhead-down-outline",
                      fill: "#000",
                      width: "25",
                      height: "25",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          _c(
            "section",
            {
              staticClass: "job-section",
              style: { backgroundImage: "url(" + _vm.background + ")" },
              attrs: { id: "job-lists" },
            },
            [
              _c("div", { staticClass: "title" }, [
                _c("span", [_vm._v(_vm._s(_vm.i18n("Homepage.JobOpenings")))]),
              ]),
              _c(
                "div",
                { staticClass: "job-list" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: { "margin-bottom": "5px" },
                    },
                    [
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.searchCondition.ManpowerDemandName,
                              expression: "searchCondition.ManpowerDemandName",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: {
                            type: "text",
                            placeholder: _vm.i18n("Homepage.Keyword"),
                          },
                          domProps: {
                            value: _vm.searchCondition.ManpowerDemandName,
                          },
                          on: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.getJobOpening.apply(null, arguments)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.searchCondition,
                                "ManpowerDemandName",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-md-3" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                filterable: true,
                                clearable: "",
                                placeholder: "地點不拘",
                              },
                              model: {
                                value: _vm.searchCondition.WorkPlace,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchCondition,
                                    "WorkPlace",
                                    $$v
                                  )
                                },
                                expression: "searchCondition.WorkPlace",
                              },
                            },
                            _vm._l(_vm.workplaceOptions, function (workplace) {
                              return _c("el-option", {
                                key: workplace.Guid,
                                attrs: {
                                  label: workplace.WorkPlaceName,
                                  value: workplace.WorkPlaceName,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "col-md-2" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm w-100",
                            staticStyle: {
                              "margin-bottom": "5px",
                              height: "37px",
                              background: "#f54c4a",
                              color: "#fff",
                            },
                            on: { click: _vm.getJobOpening },
                          },
                          [
                            _c("eva-icon", {
                              attrs: { name: "search-outline", fill: "#fff" },
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.i18n("Homepage.Search")) + " "
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._l(_vm.jobOpeningList, function (item) {
                    return _c("div", { key: item.No, staticClass: "job" }, [
                      _c("div", { staticClass: "info" }, [
                        _c(
                          "div",
                          {
                            staticClass: "name",
                            on: {
                              click: function ($event) {
                                return _vm.jobModal(item)
                              },
                            },
                          },
                          [
                            _vm._v(" " + _vm._s(item.ManpowerDemandName) + " "),
                            _c("eva-icon", {
                              attrs: {
                                name: "question-mark-circle",
                                fill: "red",
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "tag" },
                              _vm._l(item.WorkPlace, function (place) {
                                return _c("span", { key: place }, [
                                  _vm._v(" " + _vm._s(place) + " "),
                                ])
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                        _c("br"),
                        _c(
                          "div",
                          { staticClass: "tag" },
                          [
                            item.WorkExperienceWhatever
                              ? _c("span", [
                                  _vm._v(
                                    " 工作經驗不拘 Regardless of work experience "
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(item.WorkExperience) + " 年以上"
                                  ),
                                ]),
                            item.EducationDemandWhatever
                              ? _c("span", [
                                  _vm._v(" 學歷不拘 Regardless of education "),
                                ])
                              : _vm._l(
                                  item.EducationDemand,
                                  function (education, index) {
                                    return _c("span", { key: index }, [
                                      _vm._v(" " + _vm._s(education) + " "),
                                    ])
                                  }
                                ),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "desc" }, [
                          _c("pre", { staticStyle: { "font-size": "14px" } }, [
                            _vm._v(_vm._s(item.WorkContent)),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "edit" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn",
                            attrs: { type: "btn" },
                            on: {
                              click: function ($event) {
                                return _vm.apply(item.No)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.i18n("Homepage.Recruit")) + " "
                            ),
                          ]
                        ),
                      ]),
                    ])
                  }),
                ],
                2
              ),
              _c("el-pagination", {
                staticStyle: { "text-align": "center" },
                attrs: {
                  background: "",
                  layout: "prev, pager, next",
                  "page-size": 10,
                  total: _vm.totalData,
                },
                on: { "current-change": _vm.changePage },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "jobModal",
                tabindex: "-1",
                "aria-labelledby": "jobModal",
                "aria-hidden": "true",
              },
            },
            [
              _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("span", { staticClass: "modal-title" }, [
                      _vm._v(
                        " " + _vm._s(_vm.job.ManpowerDemandName) + "-職務說明 "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _vm.job.PositionInstruction === null
                      ? _c("span", [_vm._v("尚無說明")])
                      : _c("pre", [
                          _vm._v(_vm._s(_vm.job.PositionInstruction)),
                        ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "top-icon" },
        [
          _c("eva-icon", {
            attrs: { name: "arrowhead-up-outline", fill: "#ffffff" },
            on: { click: _vm.scrollTop },
          }),
        ],
        1
      ),
      _c("Footer", { attrs: { page: "HomePage" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }